import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import loreCornerDetail from '../../assets/lore/lore_details.png';
import loreButton from '../../assets/lore/lore_button.png';

function CornerDetail({ className = '', rotationClass = '' }) {
  return (
    <img
      src={loreCornerDetail}
      alt=""
      aria-hidden="true"
      draggable={false}
      className={`pointer-events-none absolute h-[52px] w-[52px] select-none opacity-80 ${rotationClass} ${className}`}
    />
  );
}

function FooterButton({ label, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="relative h-[68px] w-[250px] appearance-none border-0 bg-transparent p-0 text-white shadow-none outline-none transition hover:opacity-90 active:scale-[0.99]"
      style={{ fontFamily: 'Karma, serif' }}
    >
      <img
        src={loreButton}
        alt=""
        aria-hidden="true"
        draggable={false}
        className="pointer-events-none absolute inset-0 h-full w-full select-none object-contain"
      />
      <span className="relative z-[1] flex h-full w-full items-center justify-center text-[18px] font-semibold translate-y-[2px]">
        {label}
      </span>
    </button>
  );
}

export default function WellEchoModal({
  open,
  onListen,
}) {
  if (!open) return null;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[12000] flex items-center justify-center overflow-hidden p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onMouseDown={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <motion.div
            className="relative z-[1] w-[620px] max-w-[94vw] bg-black/80 px-6 pb-8 pt-5 text-white shadow-[0_20px_60px_rgba(0,0,0,0.72)] sm:px-8 sm:pb-10 sm:pt-6"
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.98 }}
            transition={{ duration: 0.18, ease: 'easeOut' }}
            onMouseDown={(e) => e.stopPropagation()}
            style={{ fontFamily: 'Karma, serif' }}
          >
            <CornerDetail className="left-4 top-4" rotationClass="rotate-180" />
            <CornerDetail className="right-4 top-4" rotationClass="-rotate-90" />
            <CornerDetail className="left-4 bottom-4" rotationClass="rotate-90" />
            <CornerDetail className="right-4 bottom-4" />

            <div className="relative z-[1] mx-auto flex w-full max-w-[520px] flex-col items-center pt-6 sm:pt-8">
              <div className="text-center text-[18px] leading-[1.35] text-white/90">
                You drop the old coin into the well. Something replies.
              </div>

              <div className="mt-7 flex w-full justify-center">
                <FooterButton label="Listen" onClick={onListen} />
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
